export default [
    {
        "planName": "HUBBELL AE JOIN EMP(805222) SAVINGS AND INVESTMENT PLAN ",
        "planType": null,
        "phoneNumber": "1-877-123-4567",
        "clientNumber": "800342",
        "clientName": "HUBBELL INCORPORATED",
        "planCategoryCode": "1",
        "tracPlan": false,
        "planStatusCode": "A",
        "centuryPlan": false,
        "recordKeeper": "rec_keeper_omniplus",
        "sdaRecordKeeper": "sda_rec_keeper_none",
        "sdaRecordKeeperConversionDate": null,
        "sdaRecordKeeperEffectiveDate": null,
        "feiPlanCategoryName": "401K                                         ",
        "establishDate": "2001-01-02T05:00:00.000+00:00",
        "isTerminated": false,
        "sdaPlanNum": null,
        "planNumber": "805222",
        "dstPlanNumber": null
    }
]
